// @flow

import { type OneClickCard } from '@tectonics/prs/one-click-card/types';
import i18n from 'i18next';
import { capitalize } from '@tectonics/utils/string';

export function formatOneClickCardInfoLabel(oneClickCard: OneClickCard): string {
  return i18n.t('volcanes:payment-methods.card.oneClick.cardInfoLabel', {
    brand: capitalize(oneClickCard.brand),
    lastFour: oneClickCard.last_four,
  });
}
